import { render, staticRenderFns } from "./Pentomino.vue?vue&type=template&id=11951b81&lang=pug"
import script from "./Pentomino.vue?vue&type=script&lang=js"
export * from "./Pentomino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports